// extracted by mini-css-extract-plugin
export var stepActive = "_1r-3";
export var stepCompleted = "_1r-4";
export var stepConnectorLine = "_1r-b";
export var stepIndicatorCircle = "_1r-6";
export var stepIndicatorCircleCompleted = "_1r-7";
export var stepIndicatorCircleDefault = "_1r-8";
export var stepIndicatorTextCompleted = "_1r-9";
export var stepIndicatorTextDefault = "_1r-a";
export var stepPending = "_1r-5";
export var wizardContainer = "_1r-1";
export var wizardContent = "_1r-2";
export var wizardModal = "_1r-0";